<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-tabs card vertical pills>
        <b-tab active>
          <template #title>
            <b-spinner v-if="spinners.loading" type="grow" variant="primary" />
            <span v-else>{{ project.name }}</span>
          </template>
          <b-spinner v-if="spinners.loading" type="grow" variant="primary" />
          <ProjectForm v-else :jira_key="jira_key" noCard />
        </b-tab>
        <b-tab v-for="cr in project.changeRequests" :key="cr.id" :title="cr.name">
          <b-card-text>Tab contents 2</b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import { mapGetters, mapActions } from 'vuex';
import Services from '@/services/index';
import ProjectForm from '@/views/Project/ProjectForm';
import VT from '@/store/types';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        loading: false,
        isSaving: false,
      },
      project: {
        changeRequests: []
      },
    };
  },
  props: {
    jira_key: { type: String, required: true },
  },
  components: {
    ProjectForm,
  },
  computed: {
    // ...mapGetters('JiraProjects', ['projectCategories']),
    // categories() { return Object.values(this.projectCategories); },
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    // isEmbedded() { return this.$options.propsData.value !== undefined; },
  },
  methods: {
    load() {
      this.spinners.loading = true;
      Services.projects.info_full(this.jira_key).then(({ data }) => {
        this.spinners.loading = false;
        this.project = data.project;
        // this.clients = clients.data.data;
        // this.entity = this.isUpdateForm ? data.project : { ...this.entity, ...data.project };
      }).catch((data) => {
        console.warn(data);
        this.spinners.loading = false;
      });
    },
  }
};
</script>

<style scoped>

</style>
